<template>
    <div class="container">
        <div class="rights-tit">
            <div class="top-title">领活力值升级，解锁丰富权益</div>
            <div class="top-rightarea">
                <div class="top-desc" @click="moreGradeClick">更多权益</div>
                <div class="top-arrow"></div>
            </div>
        </div>
        <div class="crad-area">
            <div
                class="card-item"
                v-for="(item, index) in lowerBenefitData.benefitList"
                :key="index"
                @click="gradeItemClick(item)"
            >
                <div class="card-tit">{{ item.title }}</div>
                <div class="card-value1">
                    {{ item.desc }}
                </div>
                <div class="butn-with-gray">
                    {{ item.extraDesc }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['lowerBenefitData', 'scoreInfoData', 'switch3DCat'],
    data() {
        return {};
    },
    watch: {
        currScoreData: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV) {
                    newV.forEach(item => {
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_privilege_grade',
                            tgt_name: 'h5-ACT-成长权益-等级权益',
                            param: this.scoreInfoData.totalScore,
                            param1: '0等级',
                            param2: item.title,
                            param3: item.desc,
                            param4: item.extraDesc,
                            param5: this.scoreInfoData.allScore,
                            param7: this.$route.query.source,
                            param8: this.switch3DCat ? '是' : '否'
                        });
                    });
                }
            }
        }
    },
    methods: {
        gradeItemClick(item) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-等级权益',
                tgt_event_id: 'h5_ACT_privilege_grade',
                param: this.scoreInfoData.totalScore,
                param1: '0等级',
                param2: item.title,
                param3: item.desc,
                param4: item.extraDesc,
                param5: this.scoreInfoData.allScore,
                param7: this.$route.query.source,
                param8: this.switch3DCat ? '是' : '否'
            });
            this.$emit('OnlowerItemClick');
        },
        moreGradeClick() {
            this.$emit('OnAllbenefitClick');
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
.container {
    background-color: #fff;
    padding-top: 24px;
    border-radius: 10px 10px 0 0;
    margin-top: -8px;
    .rights-tit {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 2px 18px 0;
        .top-title {
            color: #002a3c;
            font-size: 18px;
            font-weight: bold;
        }
        .top-rightarea {
            display: flex;
            flex-direction: row;
            margin-top: 4px;
            .top-desc {
                color: #254d5e;
                font-size: 13px;
                // font-family: fzlt;
            }
            .top-arrow {
                margin-left: 8px;
                width: 6px;
                height: 10px;
                background-size: 100% 100%;
                background-image: url('@{asserts}/mygrade-arrow@2x.png');
            }
        }
    }
    .crad-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        padding: 15px 14px 10px 16px;
        overflow: hidden;
        .card-item {
            width: 86px;
            height: 90px;
            background-size: 100% 100%;
            background-image: url('@{asserts}/lowerRight-card@2x.png');
            text-align: center;
            .card-tit {
                margin-top: 11px;
                font-size: 12px;
                color: #fff;
                font-family: fzlt_bold;
            }
            .card-value1 {
                margin-top: 18px;
                color: #faa72d;
                font-size: 13px;
                font-family: fzlt_bold;
            }
            .butn-with-gray {
                margin: 6px 0 0;
                width: 100%;
                height: 20px;
                font-size: 10px;
                font-family: fzlt;
                color: #3f5862;
            }
        }
    }
}
</style>
